<template>
  <v-sheet
    :style="{
      top: `${MENU_BAR_HEIGHT}px`
    }"
    class="sticky-lg"
    color="transparent"
    style="z-index: 2"
  >
    <v-row v-if="navItems" no-gutters>
      <v-col
        v-for="item in navItems.filter(item => !item.hidden)"
        :key="item.key"
        class="text-center"
        style="border: 2px solid transparent"
      >
        <v-btn
          :href="item.href"
          block
          class="text-none elevation-4"
          color="blue-darken-4"
          exact
          rounded="0"
          size="x-large"
          @click="emit('click', item)"
        >
          {{ item.title }}
        </v-btn>
      </v-col>
    </v-row>
  </v-sheet>
</template>

<script setup lang="ts">
import { MENU_BAR_HEIGHT } from '#root/lib/consts'

const emit = defineEmits(['click'])

defineProps<{
  navItems: {
    hidden?: boolean
    href?: string
    key: string
    title: string
  }[]
}>()
</script>
